import type { ReactNode } from 'react'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/** Карточка секции с заголовком — или голые кнопки внутри карточки отказа.
 *  `note` — своя строка под заголовком (у статьи — про читателей, а не учеников). */
export const ChangesFrame = ({
  bare,
  live,
  note,
  children,
}: {
  bare?: boolean
  live: boolean
  note?: string
  children: ReactNode
}) => {
  const m = useMessages(messages)
  if (bare) return <section className="space-y-3">{children}</section>
  return (
    <section className="space-y-4 rounded-2xl bg-foreground/5 p-5">
      <div className="space-y-1">
        <h3 className="text-base font-medium">{m.changes}</h3>
        <p className="text-sm text-muted-foreground">
          {note ?? (live ? m.liveChanges : m.draftChanges)}
        </p>
      </div>
      {children}
    </section>
  )
}
